import { UserRolesEnum, UserProps } from "../typings";
import { TableColumnProps } from "../typings/global";

// ─── Single Source of Truth for Roles ────────────────────────────────────────
// This mirrors the API's role format exactly: { id, name }
// Use the `id` when sending/receiving from the API.
// Use `name` for display purposes only.
export const ROLES: { id: UserRolesEnum; name: string }[] = [
  { id: UserRolesEnum.SUPER_ADMIN, name: "Super Admin" },
  { id: UserRolesEnum.ADMIN, name: "Admin" },
  { id: UserRolesEnum.STUDENT, name: "Student" },
  { id: UserRolesEnum.ACCOUNTANT, name: "Accountant" },
  { id: UserRolesEnum.MENTOR, name: "Mentor" },
  { id: UserRolesEnum.INTERVIEWER, name: "Interviewer" },
  { id: UserRolesEnum.DONOR, name: "Donor" },
];

// ─── Single Source of Truth for Contribution Reminder Frequencies ─────────────
// `id` is sent to / received from the API.
// `name` is for display purposes only.
export const FREQUENCIES: { id: string; name: string }[] = [
  { id: "DAILY", name: "Daily" },
  { id: "WEEKLY", name: "Weekly" },
  { id: "MONTHLY", name: "Monthly" },
  { id: "QUARTERLY", name: "Quarterly" },
  { id: "YEARLY", name: "Yearly" },
  { id: "NEVER", name: "Never" },
];

// ─── Dropdown-friendly list (derived from ROLES) ──────────────────────────────
// `value` = id (what gets sent to the API / stored in state)
// `label` = name (what the user sees)
export const USER_ROLES: { label: string; value: UserRolesEnum }[] =
  ROLES.map((r) => ({ label: r.name, value: r.id }));

// Helper: get display name from a role id
export const getRoleName = (roleId: string): string =>
  ROLES.find((r) => r.id === (roleId as UserRolesEnum))?.name ?? roleId;

export const USER_INITIAL_VALUES: UserProps = {
  id: 0,
  name: "",
  email: "",
  password: "",
  role: UserRolesEnum.STUDENT,
};

export const USERS_TABLE_COLUMNS: TableColumnProps[] = [
  { id: "id", label: "ID", minWidth: 80 },
  { id: "name", label: "Name", minWidth: 100 },
  { id: "email", label: "Email", minWidth: 200 },
  { id: "role", label: "Role", minWidth: 100, format: (value: string) => getRoleName(value) },
];
